import { render, staticRenderFns } from "./SetupStep01.vue?vue&type=template&id=5febf7f3&"
import script from "./SetupStep01.vue?vue&type=script&lang=js&"
export * from "./SetupStep01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports